import { uniTestkitFactoryCreator } from '@wix/wix-ui-test-utils/vanilla';
import { default as TableUniDriver } from '../components/Table/Table.uni.driver';
import PickerStandaloneUniDriver from '../components/PickerStandalone/PickerStandalone.uni.driver';
import { default as PickerModalUniDriver } from '../components/PickerModal/PickerModal.uni.driver';
import { CollectionViewsDropdownUniDriver } from '../components/CollectionViewsDropdown/CollectionViewsDropdown.uni.driver';
import { CollectionSaveViewModalUniDriver } from '../components/CollectionViewsDropdown/modals/SaveView/CollectionSaveViewModal.uni.driver';
import { GridUniDriver } from '../components/Grid/Grid.uni.driver';
import { TableGridSwitchUniDriver } from '../components/TableGridSwitch/TableGridSwitch.uni.driver';
import GridFoldersUniDriver from '../components/Grid/GridFolders.uni.driver';
import { KanbanUniDriver } from '../components/Kanban/Kanban.uni.driver';
import TableFoldersUniDriver from '../components/TableFolders/TableFolders.uni.driver';
import TableGridSwitchFoldersUniDriver from '../components/TableGridSwitchFolders/TableGridSwitchFolders.uni.driver';
import CustomFieldsWidgetUniDriver from '../components/CustomFieldsWidget/CustomFieldsWidget.uni.driver';
import { NestedTableUniDriver } from '../components/NestedTable/NestedTable.uni.driver';
import CustomFieldsViewWidgetUniDriver from '../components/CustomFieldsWidget/CustomFieldsViewWidget.uni.driver';
import TagsWidgetUniDriver from '../components/TagsWidget/TagsWidget.uni.driver';
import { EntityPageUniDriver } from '../components/EntityPage/EntityPage.uni.driver';
import { SettingsPageUniDriver } from '../components/SettingsPage/SettingsPage.uni.driver';
import CollectionPageUniDriver from '../components/CollectionPageNew/CollectionPage.uni.driver';
import SkeletonCardUniDriver from '../components/SkeletonCard/SkeletonCard.uni.driver';
import ErrorCardUniDriver from '../components/ErrorCard/ErrorCard.uni.driver';
import PageErrorStateUniDriver from '../components/PageErrorState/PageErrorState.uni.driver';
import CardContainerUniDriver from '../components/CardContainer/CardContainer.uni.driver';
import SubTitleUniDriver from '../components/PageSubTitle/PageSubTitle.uni.driver';
import { CustomFieldModalUniDriver } from '../components/CustomFieldModal/CustomFieldModal.uni.driver';
import RequestIdUniDriver from '../components/RequestId/RequestId.uni.driver';
import { SearchableCollectionContentUniDriver } from '../components/SearchableCollectionContent/SearchableCollectionContent.uni.driver';
import { SuggestionsUniDriver } from '../components/Suggestions/Suggestions.uni.driver';
import { default as EditableTableUniDriver } from '../components/EditableTable/EditableTable.uni.driver';
import { LayoutSwitchUniDriver } from '../components/LayoutSwitch/LayoutSwitch.uni.driver';
import SetupWidgetUniDriver from '../components/SetupWidget/SetupWidget.uni.driver';

export const TableTestkit = uniTestkitFactoryCreator(TableUniDriver);

export const GridTestkit = uniTestkitFactoryCreator(GridUniDriver);

export const TableGridSwitchTestkit = uniTestkitFactoryCreator(
  TableGridSwitchUniDriver,
);

export const EntityPageTestkit = uniTestkitFactoryCreator(EntityPageUniDriver);

export const SettingsPageTestkit = uniTestkitFactoryCreator(
  SettingsPageUniDriver,
);

export const CollectionPageTestkit = uniTestkitFactoryCreator(
  CollectionPageUniDriver,
);

export const CardContainerTestkit = uniTestkitFactoryCreator(
  CardContainerUniDriver,
);

export const CustomFieldsWidgetTestkit = uniTestkitFactoryCreator(
  CustomFieldsWidgetUniDriver,
);

export const CustomFieldsViewWidgetTestkit = uniTestkitFactoryCreator(
  CustomFieldsViewWidgetUniDriver,
);

export const TagsWidgetTestkit = uniTestkitFactoryCreator(TagsWidgetUniDriver);

export const GridFoldersTestkit =
  uniTestkitFactoryCreator(GridFoldersUniDriver);
export const TableFoldersTestkit = uniTestkitFactoryCreator(
  TableFoldersUniDriver,
);
export const NestedTableTestkit =
  uniTestkitFactoryCreator(NestedTableUniDriver);

export const KanbanTestkit = uniTestkitFactoryCreator(KanbanUniDriver);

export const TableGridSwitchFoldersTestkit = uniTestkitFactoryCreator(
  TableGridSwitchFoldersUniDriver,
);

export const PickerStandaloneTestkit = uniTestkitFactoryCreator(
  PickerStandaloneUniDriver,
);

export const PickerModalTestkit =
  uniTestkitFactoryCreator(PickerModalUniDriver);

export const ViewsStandaloneTestkit = uniTestkitFactoryCreator(
  CollectionViewsDropdownUniDriver,
);

export const ViewsStandaloneSaveModalTestkit = uniTestkitFactoryCreator(
  CollectionSaveViewModalUniDriver,
);

export const SkeletonCardTestkit = uniTestkitFactoryCreator(
  SkeletonCardUniDriver,
);
export const ErrorCardTestkit = uniTestkitFactoryCreator(ErrorCardUniDriver);

export const PageErrorStateTestkit = uniTestkitFactoryCreator(
  PageErrorStateUniDriver,
);

export const PageSubTitleTestkit = uniTestkitFactoryCreator(SubTitleUniDriver);

export const CustomFieldModalTestkit = uniTestkitFactoryCreator(
  CustomFieldModalUniDriver,
);

export const RequestIdTestkit = uniTestkitFactoryCreator(RequestIdUniDriver);

export const SearchableCollectionContentTestkit = uniTestkitFactoryCreator(
  SearchableCollectionContentUniDriver,
);

export const SuggestionsTestkit =
  uniTestkitFactoryCreator(SuggestionsUniDriver);

export const EditableTableTestkit = uniTestkitFactoryCreator(
  EditableTableUniDriver,
);

export const LayoutSwitchTestkit = uniTestkitFactoryCreator(
  LayoutSwitchUniDriver,
);

export const SetupWidgetTestkit =
  uniTestkitFactoryCreator(SetupWidgetUniDriver);
